<template>
	<div class="main">
		<div class="grzx-left">
			<div class="user-name">
				{{userInfo.name}}
			</div>
			<div class="user-head">
				<img :src="userInfo.headImg ? $imgUrl + userInfo.headImg : '../../../static/user_head.png'" alt="">
			</div>
			<Upload
				class="change-head-button"
				ref="img_ref"
				:action="$baseUrl + '/sys/accessory/uploadFile'"
				:on-success="successUpload"
				:max-size="10240"
				name="uploadFile">
				{{lang == 'zh' ? '修改头像' : 'Change Avatar'}}
			</Upload>
			<div class="user-point">
				{{lang == 'zh' ? '总积分' : 'Total Point'}}：{{userInfo.integral}}
			</div>
			<div class="grzx-box" v-for="(item, index) in leftList" @click="jumpTo(index)" :style="{borderBottom: index == 4 ? '' : '1px solid #C5C5C5', color: index === selectIndex ? '#2D5AC3' : ''}">
				<div>
					<i class="iconfont" :class="item.icon">

					</i>
				</div>
				<div style="margin-left: 10px;">
					{{lang == 'zh' ? item.name : item.en_name}}
				</div>
			</div>
		</div>
		<div class="grzx-right">
			<Row style="height: 40px; line-height: 40px; font-size: 11px; color: #686868;">
				<Col>
					{{lang == 'zh' ? '订单状态': 'Order status'}}：
				</Col>
				<Col style="margin-left: 10px;">
					<RadioGroup v-model="params.ticketStatus" @on-change="search">
						<Radio v-for="(item, index) in statusList" :key="index" :label="item.key">
							{{lang == 'zh' ? item.name : item.en_name}}
						</Radio>
					</RadioGroup>
				</Col>
			</Row>
			<div class="button-list">
				<div class="search">

				</div>
				<div class="continue-buy" @click="jumpBuy">
					{{lang == 'zh' ? '继续购票' : 'CONTINUE TO BUY'}}
				</div>
			</div>
			<Row class="ddxx-top">
				<Col span="3">
					{{lang == 'zh' ? '订单编号' : 'Order number'}}
				</Col>
				<Col span="6">
					{{lang == 'zh' ? '下单时间' : 'Order time'}}
				</Col>
				<Col span="6">
					{{lang == 'zh' ? '门票信息' : 'Ticket information'}}
				</Col>
				<Col span="4">
					{{lang == 'zh' ? '入馆时间' : 'Entry time'}}
				</Col>
				<Col span="2">
					{{lang == 'zh' ? '订单状态' : 'Order status'}}
				</Col>
				<Col span="3">
					{{lang == 'zh' ? '操作' : 'Operation'}}
				</Col>
			</Row>
			<Row class="ddxx-block" v-for="(item, index) in dataList" :key="index">
				<Col span="3">
					{{item.partnerOrderId}}
				</Col>
				<Col span="6">
					{{item.createdTime}}
				</Col>
				<Col span="6">
					<span v-if="item.orderType == 'TEAM'">
						{{item.userOrg.orgName}}{{lang == 'zh' ? ' 团体票  x ' : 'Group tickets  x '}}{{item.ticketVisits.length}}
					</span>
					<span v-else>
						{{lang == 'zh' ? '个人票  x ' : 'Individual tickets  x '}}{{item.ticketVisits.length}}
					</span>
				</Col>
				<Col span="4">
					 {{item.visitDate + ' ' + item.visitTime}}
				</Col>
				<Col span="2">
					{{lang === 'zh' ? item.ticketStatusStr : statusObj[item.ticketStatusStr]}}
				</Col>
				<Col span="3" v-if="item.ticketStatus == 'NOT_VISITED'" class="button-options" style="display: flex; justify-content: space-around;">
					<div style="cursor: pointer; margin: 0 10px;" @click="commitCancel(item.id)">
						{{lang == 'zh' ? '退票' : 'Refund'}}
					</div>
					<div style="cursor: pointer; margin: 0 10px;" @click="toDetails(item)">
						{{lang == 'zh' ? '查看' : 'View'}}
					</div>
				</Col>
				<Col span="3" v-else class="button-options">
					<div style="cursor: pointer;" @click="toDetails(item)">
						{{lang == 'zh' ? '查看' : 'View'}}
					</div>
				</Col>
			</Row>
			<page :pageObj="params" @getDataList="getData" ref="page"></page>
		</div>
		<Modal
			v-model="showCancel"
			@on-ok="toCancel"
			:cancel-text="lang == 'zh' ? '取消' : 'Cancel'"
			:ok-text="lang == 'zh' ? '确认' : 'Confirm'"
			:mask-closable="false"
			:closable="false"
			@on-cancel="showCancel = false">
			<div slot="header" style="height: 45px; line-height: 45px; text-align: center; font-size: 12px; padding: 0;">
				{{lang == 'zh' ? '温馨提示' : 'Warm prompt'}}
			</div>
			<div style="display: flex; margin: 20px; height: 30px; line-height: 30px;">
				<Icon type="ios-alert-outline" size="30" color="#127EBD"/>
				<p style="margin-left: 20px;">{{lang == 'zh' ? '请确认是否退票？' : 'Please confirm whether to refund the ticket or not.'}}</p>
			</div>
		</Modal>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page
		},
		data () {
			return {
				leftList: [
					{
						name: '个人信息',
						en_name: 'Information',
						path: '/grxx',
						icon: 'iconyonghu1'
					},
					{
						name: '我的门票预约',
						en_name: 'Ticket',
						path: '/wdmpyy',
						icon: 'iconmenpiao'
					},
					{
						name: '我的活动预约',
						en_name: 'Activity',
						path: '/wdhdyy',
						icon: 'iconliwu'
					},
					// {
					// 	name: '我的点赞',
					// 	path: '/wddz',
					// 	icon: 'icondianzan'
					// },
					// {
					// 	name: '我的收藏',
					// 	path: '/wdsc',
					// 	icon: 'iconcollection-b'
					// },
				],
				selectIndex: 1,
				params: {
					current: 1,
					size: 6,
					url: '/api/ticket/ck/findMyTicketInfo',
					// idCard: '',
					// start: '',
					// end: '',
					ticketStatus: null
				},
				statusList: [
					{
						name: '全部',
						en_name: 'All',
						key: null
					},
					{
						name: '未入馆',
						en_name: 'Not in the library',
						key: 'NOT_VISITED'
					},
					{
						name: '已入馆',
						en_name: 'Entered the Museum',
						key: 'VISITED'
					},
					{
						name: '已退票',
						en_name: 'Refunded',
						key: 'CANCEL'
					},
					{
						name: '过期未入馆',
						en_name: 'Overdue',
						key: 'OVER_TIME'
					}
				],
				dataList: [],
				userInfo: {

				},
				chooseOrderId: "",
				showCancel: false,
				statusObj: {
					"未参观": "To be visited",
					"已参观": "Visited",
					"已取消": "Cancelled",
					"待审核": "To be audit",
					"审核不通过": "Audit failed",
					"过期未入馆": "Overdue"
				}
			}
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../static/hyzx_top.png'
			that.getUserInfo()
		},
		methods: {
			successUpload(res) {
				let that = this
				if(res.code === 'S200') {
					that.$http.post({
						url: '/api/user/ck/updateUser',
						data: {
							id: that.$http.getStorage('userId'),
							headImg: res.data.id
						}
					}).then(ress => {
						if(ress.code === 'S200') {
							that.getUserInfo()
						} else {
							that.$Message.error(ress.msg)
						}
					})
				}
			},
			getUserInfo() {
				let that = this
				that.$http.post({
					url: '/api/user/ck/getUserDetail',
					data: {
						id: that.$http.getStorage('userId')
					}
				}).then(res => {
					if(res.code === 'S200') {
						if(res.data) {
							that.userInfo = res.data
						} else {
							that.userInfo = {}
						}
					} else if(res.code === 'F001') {
						that.$router.push('login')
					}
				})
			},
			jumpTo(index) {
				let that = this
				if(index === that.selectIndex) {
					return
				}
				that.$router.push(that.leftList[index].path)
			},
			getData(dataList) {
				let that = this
				that.dataList = dataList
			},
			toDetails(item) {

				this.$http.setStorage('ticket', JSON.stringify(item))
				this.$router.push({
					path: '/wdmpyy_details'
				})
			},
			jumpBuy() {
				if(this.lang === 'zh') {
					this.$router.push({
						path: '/mpyy'
					})
				} else {
					this.$router.push({
						path: '/ticketbooking'
					})
				}

			},
			search() {
				let that = this
				that.params.current = 1
				that.$refs.page.getData()
			},
			commitCancel(orderId) {
				let that = this
				that.showCancel = true
				that.chooseOrderId = orderId
			},
			toCancel() {
				let that = this
				that.$http.post({
					url: '/api/ticket/ck/cancelTicket',
					data: {
						id: that.chooseOrderId
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.params.current = 1
						that.$refs.page.getData()
					} else {
						that.$Message.error(res.msg)
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 80%;
		margin: 30px 10% 150px;
		display: flex;
		justify-content: space-between;
		.grzx-left {
			width: 15%;
			padding: 10px 20px;
			background-color: #F6F8FF;
			height: 550px;
			.user-name {
				color: #264EA7;
				font-size: 16px;
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
				height: 30px;
				line-height: 30px;
			}
			.user-head {
				width: 75px;
				height: 75px;
				margin: 10px auto;
				border-radius: 50%;
				img {
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
			.change-head-button {
				width: 115px;
				height: 25px;
				line-height: 25px;
				margin: 0 auto;
				text-align: center;
				background-color: #264EA7;
				border-radius: 10px;
				color: #FFFFFF;
				font-size: 9px;
				cursor: pointer;
			}
			.user-level {
				width: 70%;
				margin: 10px auto;
				display: flex;
				justify-content: center;
				height: 25px;
				.left {
					border-top: 3px solid #D3D3D3;
					border-bottom: 3px solid #D3D3D3;
					color: #D3D3D3;
					display: flex;
					i {
						font-size: 14px;
					}
				}
				.right {
					background-color: #EDD68E;
					color: #0E40DF;
					font-size: 12px;
					line-height: 25px;
					padding: 0 10px;
				}
			}
			.user-point {
				color: #264EA7;
				font-size: 12px;
				height: 30px;
				line-height: 30px;
			}
			.grzx-box {
				height: 60px;
				line-height: 60px;
				text-align: left;
				display: flex;
				font-size: 13px;
				color: #686868;
				cursor: pointer;
				.iconfont {
					font-size: 16px;
					color: #2D5AC3;
				}
			}
		}
		.grzx-right {
			width: 80%;
			.button-list {
				display: flex;
				justify-content: space-between;
				margin-top: 20px;
				height: 30px;
				line-height: 30px;
				color: #FFFFFF;
				font-size: 12px;
				.search {
					width: 80px;
					// background-color: #1173E1;
					text-align: center;
					cursor: pointer;
				}
				.continue-buy {
					width: 150px;
					background-color: #1173E1;
					text-align: center;
					cursor: pointer;
				}
			}
			.ddxx-top {
				height: 40px;
				line-height: 40px;
				background-color: #1173E1;
				color: #FFFFFF;
				font-size: 12px;
				margin-top: 20px;
				text-align: center;
			}
			.ddxx-block {
				height: 40px;
				line-height: 40px;
				color: #686868;
				font-size: 12px;
				text-align: center;
				border-bottom: 1px solid #808080;
				.button-options {
					color: #1059BF;
					width: 100%;
					text-align: center;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/user_center/wdmpyy.vue